import { el, mount, unmount } from 'redom';

import application from 'application';

import { stringToSVG } from 'utilities';
import { preventPropogation } from 'utilities/dom';

import * as deviceAccessStatuses from 'constants/device-access-statuses';

import Tooltip from './tooltip';

import cameraActiveIconString from 'assets/images/camera-active-icon.svg?raw';
import cameraInactiveIconString from 'assets/images/camera-inactive-icon.svg?raw';

const cameraActiveIcon = stringToSVG(cameraActiveIconString);
const cameraInactiveIcon = stringToSVG(cameraInactiveIconString);

class VideoControls {

  constructor(videoOptions = true, stopped = true) {

    this.startButton = el('button.meeting-video-start-button.meeting-room-control', [cameraActiveIcon.cloneNode(true)]);
    this.stopButton = el('button.meeting-video-stop-button.meeting-room-control', [cameraInactiveIcon.cloneNode(true)]);

    this.startButtonWithTooltip = new Tooltip(this.startButton, '.start-video-button-tooltip', 'Start camera');
    this.stopButtonWithTooltip = new Tooltip(this.stopButton, '.stop-video-button-tooltip', 'Stop camera');

    this.el = el('.screen-video-controls-main');

    this.stream = null;
    this.stopped = stopped;
    this.videoOptions = videoOptions;

    if (this.stopped === true) {
      this.mountStartButton();
    } else {
      this.mountStopButton();
    }

  }

  onmount() {

    this.startButton.addEventListener('click', this.start.bind(this));
    this.startButton.addEventListener('dblclick', preventPropogation);

    this.stopButton.addEventListener('click', this.stop.bind(this));
    this.stopButton.addEventListener('dblclick', preventPropogation);

  }

  onunmount() {
    application.devicesManager.releaseCameraStream();
  }

  mountStartButton() {

    mount(this.el, this.startButtonWithTooltip);

  }

  unmountStartButton() {

    unmount(this.el, this.startButtonWithTooltip);

  }

  mountStopButton() {

    mount(this.el, this.stopButtonWithTooltip);

  }

  unmountStopButton() {

    unmount(this.el, this.stopButtonWithTooltip);

  }

  async getStream() {

    try {

      const stream = this.stream = await application.devicesManager.getCameraStream(this.videoOptions);

      return stream;

    } catch (exception) {

      application.devicesManager.ensureMediaPermissions(deviceAccessStatuses.ALLOWED, exception.message);

      return null;

    }

  }

  async start(event) {

    event.stopPropagation();

    const stream = await this.getStream();

    this.unmountStartButton();
    this.mountStopButton();

    const cameraStartedEvent = new CustomEvent('camera-stream-started', {
      detail: {
        stream
      }
    });

    this.el.dispatchEvent(cameraStartedEvent);

  }

  async stop(event) {

    event.stopPropagation();

    if (this.stream !== null) {

      const tracks = this.stream.getTracks();

      for (let track of tracks) {
        track.stop();
      }

      this.stream = null;

    }

    this.unmountStopButton();
    this.mountStartButton();

    const cameraStoppedEvent = new CustomEvent('camera-stream-stopped');

    this.el.dispatchEvent(cameraStoppedEvent);

  }

}

export default VideoControls;